import Box from '@mui/material/Box';

interface Props {
    children: any;
}

const ListStylesContainer = ({ children }: Props) => (
    <Box
        sx={{
            '& .RaList-actions': {
                display: 'grid',
                gridTemplateColumns: 'auto 1fr',
                gap: 2,
                alignItems: 'center',
                pt: 1,
                px: 2,
                pb: 2,
                '> form': {
                    display: 'flex',
                    gap: 2,
                    alignItems: 'start',
                    minHeight: 0,
                },
                '> span': {
                    display: 'none',
                },
                '.RaFilterFormInput-spacer': {
                    display: 'none',
                },
                '> div.MuiToolbar-root': {
                    m: '0 !important',
                    minHeight: 0,
                    p: 0,
                    justifySelf: 'end',
                },
                width: 'auto',
            },
            '& .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root': {
                fontWeight: 700,
                borderBottom: '2px rgb(9,23,71,0.1) solid',
            },
            '& .MuiTableBody-root .MuiTableRow-root .MuiTableCell-root': {
                borderBottom: 0,
            },
            '& .RaBulkActionsToolbar-toolbar': {
                display: 'grid',
                gridTemplateColumns: 'auto 1fr',
                pr: 0,
            },
        }}
    >
        {children}
    </Box>
);

export default ListStylesContainer;
